
import React from 'react';

import Loading from './Loading';

const ObjectList = ({objectList, children}) => {
           
    if (objectList.loading) {
        return <Loading/>
    }
        
    if (!objectList.initialized) {
        return null;
    }

    return children;
}

export default ObjectList;
